export default __webpack_public_path__ + "static/media/Ballroll_00329.5490bbe8.png";